import React, { useState, useEffect } from 'react';
import { fetchAvailableYears } from './api/googleSheet';
import Sidebar from './components/layout/Sidebar';
import RunningTable from './components/table/RunningTable';
import Dashboard from './components/dashboard/Dashboard';
import { IconHamburger } from './components/common/Icons';

export default function App() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [availableYears, setAvailableYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null); 
    const [view, setView] = useState('table'); // 'table' or 'dashboard'

    useEffect(() => {
        const initApp = async () => {
            const years = await fetchAvailableYears();
            const uniqueYears = [...new Set(years)];
            setAvailableYears(uniqueYears);
            
            const currentYear = new Date().getFullYear();
            if (uniqueYears.includes(currentYear)) {
                setSelectedYear(currentYear);
            } else if (uniqueYears.length > 0) {
                setSelectedYear(uniqueYears[0]);
            } else {
                setSelectedYear(currentYear);
            }
            setView('table');
        };
        initApp();
    }, []);

    useEffect(() => {
        if (view === 'dashboard') {
            document.title = "Dashboard | N-NRUN";
        } else if (view === 'table' && selectedYear) {
            document.title = `ตารางการแข่งขันวิ่ง ${selectedYear} | N-NRUN`;
        } else {
            document.title = "Home | N-NRUN";
        }
    }, [view, selectedYear]);

    return (
        <div className="bg-gray-100 min-h-screen font-sans">
            <Sidebar 
                isOpen={sidebarOpen} 
                setIsOpen={setSidebarOpen} 
                selectedYear={selectedYear} 
                setSelectedYear={setSelectedYear}
                view={view}
                setView={setView}
                availableYears={availableYears}
            />
            <div className="md:ml-64 transition-all duration-300 ease-in-out">
                <header className="bg-white shadow-sm p-4 flex items-center md:hidden">
                    <button onClick={() => setSidebarOpen(true)} className="text-gray-500 hover:text-gray-700">
                        <IconHamburger />
                    </button>
                    <h1 className="text-xl font-semibold text-gray-800 ml-4">
                        {view === 'dashboard' ? 'Dashboard' : `ตารางการแข่งขันวิ่ง`}
                    </h1>
                </header>
                <main className="p-4 sm:p-6 lg:p-8">
                    {view === 'table' && selectedYear && (
                        <header className="mb-8 text-center hidden md:block">
                            <h1 className="text-4xl font-extrabold text-gray-800 tracking-tight">ตารางการแข่งขันวิ่ง {selectedYear}</h1>
                            <p className="mt-2 text-lg text-gray-500">ค้นหางานวิ่งที่วางแผนการซ้อมของคุณ</p>
                        </header>
                    )}
                    
                    {view === 'dashboard' ? (
                        <Dashboard availableYears={availableYears} />
                    ) : selectedYear ? (
                        <RunningTable selectedYear={selectedYear} />
                    ) : (
                        <div className="flex justify-center items-center h-96"><div className="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div></div>
                    )}
                    
                    <footer className="text-center mt-8 text-sm text-gray-400">
                        <p>© 2025 My Personal Teerawat Project - Version 2025.0724.001</p>
                    </footer>
                </main>
            </div>
        </div>
    );
}

